// extracted by mini-css-extract-plugin
export default {"sbAppIcon":"zgJDrGz","sbCloseIcon":"FpAFAwp c_IO2I_","starsContainer":"t57Rtsb","darkStars":"WyjKSVu"};